/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import Immutable from 'immutable';
import { useCallback } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import memoizeOne from 'react-utils/memoizeOne';
import { clampLimitAndOffset } from '../report-options';
import { Status } from '../../shared/hooks/asyncState';
import useMeta from './useMeta';
import { useUserInfo } from 'reporting-snowflake/relational/metadata/user-info';
import { getDatasetInsightParams } from 'reporting-data/report/reportGetters';
export const dataRequirementsAreEquivalent = (prev, next) => {
  const {
    reportDefinition: prevReportDefinition
  } = prev;
  const {
    reportDefinition: nextReportDefinition
  } = next;
  const reportOptionsAreEqual = prev.reportOptions.equals(next.reportOptions);
  const columnsHaveSameDataRequirements = prevReportDefinition.columns.map(column => column.delete('name')).equals(nextReportDefinition.columns.map(column => column.delete('name')));
  const tablesAreEqual = prevReportDefinition.table.equals(nextReportDefinition.table);
  const sortsAreEqual = prevReportDefinition.sorts.equals(nextReportDefinition.sorts);

  // only compare filtering logic, groups, and condition
  const filteringIsEqual = Immutable.is(prevReportDefinition.filtering.delete('stagedFilters'), nextReportDefinition.filtering.delete('stagedFilters'));
  const eventDateIntervalsAreEqual = Immutable.is(prev.reportDefinition.eventDateInterval, next.reportDefinition.eventDateInterval);
  const expressionsAreEqual = Immutable.is(prevReportDefinition.get('expressions'), nextReportDefinition.get('expressions'));
  const dateComparisonFiltersAreEqual = Immutable.is(prev.reportDefinition.dateComparisonFilter, next.reportDefinition.dateComparisonFilter);
  const insightParamsAreEqual = Immutable.is(getDatasetInsightParams(prev), getDatasetInsightParams(next));
  return reportOptionsAreEqual && columnsHaveSameDataRequirements && tablesAreEqual && sortsAreEqual && filteringIsEqual && eventDateIntervalsAreEqual && dateComparisonFiltersAreEqual && expressionsAreEqual && insightParamsAreEqual;
};
export const useDifferent = value => {
  const previousValue = usePrevious(value);
  return value !== previousValue;
};

/**
 * @returns {undefined|ReportWithOptions}
 */
export const useReportToQuery = (reportWithOptions, reportId) => {
  const {
    reportDefinition
  } = reportWithOptions;
  const {
    data: meta,
    loading
  } = useMeta(reportDefinition);
  const {
    data: userInfo,
    loading: userInfoLoading
  } = useUserInfo();
  const memoizedCreateReportToResolve = useCallback(memoizeOne(report => report, dataRequirementsAreEquivalent), []);
  const reportMetaState = useMeta(reportDefinition);
  if (reportMetaState.status !== Status.SUCCEEDED || !reportMetaState.data) {
    return undefined;
  }
  const reportOptionsId = reportWithOptions.getIn(['reportOptions', 'reportIdForBustingCache']);
  const maybeReportId = reportId || reportOptionsId;
  const maybeReportWithId = maybeReportId ? reportWithOptions.set('reportId', maybeReportId) : reportWithOptions;
  if (loading || !meta || !userInfo || userInfoLoading) {
    return undefined;
  }
  const reportToResolve = maybeReportWithId.update('reportOptions', clampLimitAndOffset);
  return memoizedCreateReportToResolve(reportToResolve);
};